import { FC, HTMLAttributes, useState } from 'react';

import { Badge, Button, Popover } from 'antd';

import NotificationIcon from 'assets/images/icons/notification.svg?react';
import { useNotificationsUnreadCountRetrieveQuery } from 'entities/Notification';
import { NotificationsPopup } from 'features/NotificationsPopup';
import { useMedia } from 'shared/hooks';
import { EGaCategories, EGaEvents, EGaTypes } from 'shared/typings';
import { sendGaEvent } from 'shared/utils';

interface INotificationsProps extends HTMLAttributes<HTMLDivElement> {}

export const Notifications: FC<INotificationsProps> = () => {
	const [isOpened, setIsOpened] = useState(false);
	const isMobile = useMedia();
	const { data } = useNotificationsUnreadCountRetrieveQuery(undefined, { pollingInterval: 10000 });

	return (
		<Popover
			open={isOpened}
			onOpenChange={setIsOpened}
			{...(!isMobile && { placement: 'bottomRight' })}
			content={<NotificationsPopup setIsOpened={setIsOpened} />}
			trigger={'click'}>
			<Button
				htmlType={'button'}
				onClick={() =>
					sendGaEvent(EGaEvents.CLICK_NOTIFICATION, {
						event_option1: EGaCategories.ACCOUNT,
						event_option2: EGaTypes.HEADER,
					})
				}
				type={'text'}
				size='small'>
				<Badge dot={!!data?.unread_count}>
					<NotificationIcon />
				</Badge>
			</Button>
		</Popover>
	);
};
